// import {debounce} from '@/util/actions.js';

export const setZoomTo = (zoomTo) => ({
    type: 'SET_ZOOM_TO_BOUNDS',
    zoomTo 
});

export const setMarquee = (marquee) => ({
    type: 'SET_MARQUEE',
    marquee
})


export const setMultiselectDefault = (multiselect) => ({
    type: 'SET_MULTISELECT_DEFAULT',
    multiselect
});


export const setCurrentTool = (tool) => ({
    type: 'SET_CURRENT_TOOL',
    tool
})


export const setToolModifier = (mod) => ({
    type: 'SET_TOOL_MODIFIER',
    mod
});

export const setAspectLock = (mod) => ({
    type: 'SET_ASPECT_LOCK',
    mod
});

export default {
    setZoomTo,
    setMarquee,
    setMultiselectDefault,
    setCurrentTool,
    setToolModifier,
    setAspectLock
}